const blogs = [
  {
    image: "/images/blog2.webp",
    title: "The Best Way to Learn React",
    text: "iPad Pro is the fastest device of its kind. It’s designed to take full advantage of next‑level performance and custom technologies like the advanced image...",
    date: "12th March 2021",
  },
  {
    image: "/images/blog4.webp",
    title: "The Best Way to Learn React",
    text: "iPad Pro is the fastest device of its kind. It’s designed to take full advantage of next‑level performance and custom technologies like the advanced image...",
    date: "12th March 2021",
  },
  {
    image: "/images/blog1.webp",
    title: "The Best Way to Learn React",
    text: "iPad Pro is the fastest device of its kind. It’s designed to take full advantage of next‑level performance and custom technologies like the advanced image...",
    date: "12th March 2021",
  },
  {
    image: "/images/blog2.webp",
    title: "The Best Way to Learn React",
    text: "iPad Pro is the fastest device of its kind. It’s designed to take full advantage of next‑level performance and custom technologies like the advanced image...",
    date: "12th March 2021",
  },
  {
    image: "/images/blog3.webp",
    title: "The Best Way to Learn React",
    text: "iPad Pro is the fastest device of its kind. It’s designed to take full advantage of next‑level performance and custom technologies like the advanced image...",
    date: "12th March 2021",
  },
  {
    image: "/images/blog4.webp",
    title: "The Best Way to Learn React",
    text: "iPad Pro is the fastest device of its kind. It’s designed to take full advantage of next‑level performance and custom technologies like the advanced image...",
    date: "12th March 2021",
  },
];

export default blogs;
